// Nautische Fachbegriffe: "Magnetkompass", "Kompensierung" für das Beseitigen der Deviation,
// "Deviationstabelle" für die deviation card, "Klassifikationsgesellschaft".
const de = {
    nav: {
        about: 'Über uns',
        services: 'Leistungen',
        contact: 'Kontakt',
        language: 'Sprache',
    },
    slides: {
        s1Subtitle: 'Service und Zertifikate für Magnetkompasse seit 1939.',
        readAbout: 'Mehr über uns',
        s2Before: 'Als erstes Unternehmen bieten wir die ',
        s2Highlight: 'Fernkompensierung',
        s2After: ' von Magnetkompassen an.',
        s2Text: 'Lassen Sie Ihren Magnetkompass aus der Ferne kompensieren und erhalten Sie alle erforderlichen Zertifikate zur Vorlage bei jeder nationalen oder internationalen Behörde.',
        learnMore: 'Mehr erfahren',
        getQuote: 'Angebot anfordern',
        imgAlt: 'Schiffsbrücke mit Navigationsausrüstung',
    },
    about: {
        title: 'Über uns',
        imgAlt: 'Magnetkompass an Deck eines Schiffes',
        since: 'Seit',
        eyebrow: 'Wer wir sind',
        heading: 'Seit über 85 Jahren reparieren und kalibrieren wir Magnetkompasse.',
        text: 'Wir sind das einzige zugelassene Labor in Argentinien, das Zertifikate mit allen gesetzlichen und internationalen Anerkennungen ausstellt – weltweit anerkannt von jeder Klassifikationsgesellschaft und Küstenwache.',
        checks: [
            'Zugelassen von der PNA (Argentinien, IMO-Mitgliedstaat)',
            'Erster Anbieter der Kompasskalibrierung vollständig aus der Ferne',
            'Kalibrierung von Magnetkompassen und Zertifikate in weniger als 24 Stunden',
        ],
        counters: ['Ausgestellte Zertifikate', 'Reparierte Kompasse', 'Durchgeführte Aufträge'],
        partner: 'Offizieller Service und Vertriebspartner',
    },
    services: {
        title: 'Leistungen',
        flagship: 'Unsere Kernleistung',
        remoteTitle: 'Fernkalibrierung',
        remoteSubtitle: 'Kalibrieren Sie Ihren Magnetkompass während der Fahrt – überall auf der Welt. Ohne Techniker an Bord, ohne Hafenanlauf.',
        steps: [
            { title: 'Daten übermitteln.', text: 'Der Kapitän lädt die Kompassdaten auf unsere Online-Plattform hoch.' },
            { title: 'Anleitung erhalten.', text: 'Einfache, detaillierte Schritte zur Korrektur der Deviation.' },
            { title: 'Mit Unterstützung kompensieren.', text: 'Ein Techniker steht Ihnen rund um die Uhr für alle Fragen zur Verfügung.' },
            { title: 'Zertifikate erhalten.', text: 'Neue Deviationstabelle und Zertifikate per E-Mail.' },
        ],
        imgAlt: 'Online-Plattform',
        figcaption: 'Alle Kompassdaten an einem Ort – auf unserer Online-Plattform.',
        advShipTitle: 'Vorteile für das Schiff',
        advShip: [
            'Kompensierung während der Fahrt, ohne Hafenanlauf und ohne Verzögerung der Reise',
            'Ein Techniker rund um die Uhr erreichbar',
        ],
        advOwnersTitle: 'Vorteile für Reeder und Schiffsmanager',
        advOwners: [
            'Keine Kosten für die Ein- und Ausschiffung des Technikers',
            'Festpreis ohne Aufschläge nach Tag oder Uhrzeit; günstiger bei größerem Volumen',
        ],
        howItWorks: 'So funktioniert es',
        onboardTitle: 'Kalibrierung an Bord',
        onboardText: 'Ein Techniker kompensiert den Magnetkompass an Bord manuell und stellt die Zertifikate aus, digital signiert von Techniker und Kapitän.',
        onboardSteps: [
            'Der Techniker weist den Kapitän an, bestimmte Manöver zu fahren, um den Magnetkompass zu überprüfen und bei Bedarf zu kompensieren.',
            'Nach der Korrektur aller Deviationen stellt der Techniker an Bord die Zertifikate mit allen gesetzlichen und internationalen Anerkennungen aus. Beide werden vom Techniker und vom Kapitän digital signiert.',
        ],
        repairTitle: 'Reparatur von Magnetkompassen',
        repairText: 'Senden oder bringen Sie Ihren Kompass in unser Labor. Reparatur in weniger als 24 Stunden, mit Überholungszertifikat und einem Jahr Garantie.',
        repairSteps: [
            'Der Magnetkompass wird geprüft, um den Fehler zu ermitteln.',
            'Einer unserer Techniker repariert ihn in weniger als 24 Stunden.',
            'Nach der Reparatur stellt unser Techniker das Überholungszertifikat des Kompasses aus – mit einem Jahr Garantie.',
        ],
    },
    contact: {
        title: 'Kontakt',
        intro: 'Sie benötigen ein Angebot oder haben eine Frage? Unsere Techniker melden sich bei Ihnen.',
        getInTouch: 'Kontaktieren Sie uns',
        getInTouchText: 'Rufen Sie uns an, schreiben Sie uns oder senden Sie uns eine Nachricht. Wir sind weltweit für Sie da.',
        international: 'USA / International',
        technical: 'Technische Abteilung',
        email: 'E-Mail',
        laboratory: 'Labor',
        openMaps: 'In Maps öffnen',
        whatsapp: 'Per WhatsApp schreiben',
        showEmail: 'E-Mail anzeigen',
        form: {
            title: 'Schreiben Sie uns',
            required: 'Alle Felder sind Pflichtfelder.',
            name: 'Vollständiger Name',
            email: 'E-Mail',
            phone: 'Mobilnummer',
            enterprise: 'Unternehmen',
            subject: 'Betreff',
            message: 'Nachricht',
            recaptcha: 'Geschützt durch reCAPTCHA.',
            send: 'Nachricht senden',
            sending: 'Wird gesendet... Bitte warten.',
            sendError: 'Etwas ist schiefgelaufen! Bitte versuchen Sie es später erneut oder schreiben Sie uns direkt eine E-Mail.',
        },
        errors: {
            name: 'Bitte geben Sie Ihren Namen ein',
            email: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
            emailInvalid: 'Die E-Mail-Adresse ist ungültig',
            phone: 'Bitte geben Sie Ihre Mobilnummer ein',
            enterprise: 'Bitte geben Sie Ihr Unternehmen an',
            subject: 'Bitte geben Sie einen Betreff ein',
            message: 'Bitte geben Sie eine Nachricht ein',
        },
    },
    footer: {
        slogan: 'Service und Zertifikate für Magnetkompasse seit 1939',
        terms: 'AGB',
        policy: 'Datenschutz',
    },
}

export default de
